import SplunkClientLogger from '@its-svp/splunk-client-logger';
/* global svpGlobal */

const stubLogger = {
  info: () => {},
  error: () => {},
  warn: () => {},
  debug: () => {},
  reduxMiddleware: () => () => (next) => (action) => next(action)
};

let impl = stubLogger;

function createLogger() {
  return new SplunkClientLogger({
    endpoint: '/api/v1/session/clientLogs',
    token: 'unused',
    index: 'unused',
    sourcetype: 'unused',
    source: svpGlobal.env.SERVICE_NAME,
    console: { isEnabled: false } // turn off console hijacking
  });
}

const splunkLogger = {
  info: (...args) => impl.info(...args),
  error: (...args) => impl.error(...args),
  warn: (...args) => impl.warn(...args),
  debug: (...args) => impl.debug(...args),
  reduxMiddleware: (config) => (store) => (next) => (action) =>
    impl.reduxMiddleware(config)(store)(next)(action)
};

export const initializeLogger = () => {
  if (typeof svpGlobal === 'undefined' || !svpGlobal.env || svpGlobal.env.NODE_ENV === 'test') {
    return;
  }
  try {
    impl = createLogger();
  } catch (error) {
    impl = stubLogger;
  }
};

export default splunkLogger;



// WEBPACK FOOTER //
// ./src/utils/splunkClientLogger.js